import { module } from 'angular';
import component from './v5-frame.component';

export default module('app.v5-frame', [])
	.component('v5Frame', component)
	.name;
